import { useMutation } from '@tanstack/react-query';
import { returnStock } from '../api/repository/stock';
import { ReturnStockInterface } from '../types/stock';

type ReturnStockProps = {
    stockNumber: string;
    stock: ReturnStockInterface;
};

export const useReturnStock = () => {
    return useMutation({
        mutationFn: ({ stockNumber, stock }: ReturnStockProps) =>
            returnStock(stockNumber, stock),
    });
};
